import React from "react";
import {ConfirmChangeSliderModal, Icon, RewardsSlider, RewardsSliderInfoModal, RewardsSliderPreview} from "@housebets/housebets-x-package";

import {IRewardSliderProps} from "./types";
import {useRewardSliderData} from "./hooks/useRewardSliderData";
import {useGTMEvents} from "app/hooks/useGTMEvents";
import {useIntl} from "react-intl";

export const RewardSlider: React.FC<IRewardSliderProps> = ({simpleView}) => {
    const {$t} = useIntl();

    const {
        weekDropdownValue,
        monthDropdownValue,
        sliderTabIndex,
        setSliderTabIndex,
        level,
        weekRange,
        setWeekValue,
        monthRange,
        setMonthValue,
        onConfirm,
        onSubmit,
        isOpen,
        setIsOpen,
        showConfirmButton,
        // enabled slider confirm modal
        sliderConfirmModal,
        setSliderConfirmModal,
        isFetching,
        // disabled slider confirm modal
        disabledChangeInfoModal,
        setDisabledChangeInfoModal,
    } = useRewardSliderData();
    const {modal} = useGTMEvents();

    if (simpleView) {
        return (
            <RewardsSliderPreview
                weekRange={weekDropdownValue}
                monthRange={monthDropdownValue}
                texts={{
                    lossback: $t({id: "RewardsSliderPreview.lossback"}),
                    rackeback: $t({id: "RewardsSliderPreview.rakeback"}),
                    monthBtn: $t({id: "RewardsSliderPreview.monthBtn"}),
                    weekBtn: $t({id: "RewardsSliderPreview.weekBtn"}),
                    title: $t({id: "RewardsSliderPreview.title"}),
                    lockTitle: $t({id: "RewardsSliderPreview.lockedWeekTitle"}),
                    lockWeekSubTitle: $t({id: "RewardsSliderPreview.lockWeekSubTitle"}),
                    lockMonthSubTitle: $t({id: "RewardsSliderPreview.lockMonthSubTitle"}),
                }}
            />
        );
    }
    return (
        <>
            <RewardsSlider
                texts={{
                    title: $t({id: "RewardsSlider.title"}),
                    description: $t({id: "RewardsSlider.description"}),
                    confirmButton: $t({id: "RewardsSlider.confirmButton"}),
                    weekly: $t({id: "RewardsSlider.weekly"}),
                    monthly: $t({id: "RewardsSlider.monthly"}),
                    rakeback: $t({id: "RewardsSlider.rakeback"}),
                    lossback: $t({id: "RewardsSlider.lossback"}),
                    lockedWeekTitle: $t({id: "RewardsSlider.lockedWeekTitle"}),
                    lockedMonthTitle: $t({id: "RewardsSlider.lockedMonthTitle"}),
                    lockedWeekSubtitle: $t({id: "RewardsSlider.lockedWeekSubtitle"}),
                    lockedMonthSubtitle: $t({id: "RewardsSlider.lockedMonthSubtitle"}),
                }}
                initActiveTab={sliderTabIndex}
                onTabChange={setSliderTabIndex}
                weekRange={{
                    ...weekRange,
                    isLocked: level < 7,
                    onChange: (v) => setWeekValue(v),
                }}
                monthRange={{
                    ...monthRange,
                    isLocked: level < 16,
                    onChange: (v) => setMonthValue(v),
                }}
                onTooltipClick={() => {
                    setIsOpen(true);
                }}
                onConfirm={onConfirm}
                showConfirmButton={showConfirmButton}
            />
            <RewardsSliderInfoModal
                isOpen={isOpen}
                texts={{
                    title: $t({id: "RewardsSliderInfoModal.title"}),
                    description: $t({id: "RewardsSliderInfoModal.description"}),
                    rakeback: $t({id: "RewardsSliderInfoModal.rakeback"}),
                    lossback: $t({id: "RewardsSliderInfoModal.lossback"}),
                }}
                onClose={() => setIsOpen(false)}
                afterOpenModal={() => {
                    modal.show("reward_slider_info");
                }}
                onAfterClose={() => {
                    modal.close("reward_slider_info");
                }}
            />
            <ConfirmChangeSliderModal
                isOpen={sliderConfirmModal.isOpen}
                onClose={() => {
                    setSliderConfirmModal((prev) => ({
                        ...prev,
                        isOpen: false,
                    }));
                }}
                onSubmit={onSubmit}
                date={sliderConfirmModal.type === "week" ? sliderConfirmModal.timeLeftWeek : sliderConfirmModal.timeLeftMonth}
                proceed={sliderConfirmModal.processed}
                showDays
                showSeconds
                isLoading={isFetching}
                text={{
                    confirmCancelBtn: $t({id: "ConfirmChangeSliderModal.confirmCancelBtn"}),
                    confirmSuccessBtn: $t({id: "ConfirmChangeSliderModal.confirmSuccessBtn"}),
                    confirmedTitle: $t({id: "ConfirmChangeSliderModal.confirmedTitle"}),
                    title: (
                        <>
                            <Icon iconName="AlertOrange" /> {$t({id: "ConfirmChangeSliderModal.title"})}
                        </>
                    ),
                    confirmText: $t({id: "RewardsSlider.confirmText"}, {period: sliderConfirmModal.type === "week" ? $t({id: "thursday"}) : $t({id: "month"})}),
                    timerText: $t({id: "RewardsSlider.timerText"}),
                }}
                afterOpenModal={() => {
                    modal.show("reward_slider_confirm");
                }}
                onAfterClose={() => {
                    modal.close("reward_slider_confirm");
                }}
            />
            <ConfirmChangeSliderModal
                isOpen={disabledChangeInfoModal.isOpen}
                onClose={() => {
                    setDisabledChangeInfoModal((prev) => ({
                        ...prev,
                        isOpen: false,
                    }));
                }}
                onSubmit={() => {}}
                date={disabledChangeInfoModal.type === "week" ? disabledChangeInfoModal.timeLeftWeek : disabledChangeInfoModal.timeLeftMonth}
                proceed
                showDays
                showSeconds
                text={{
                    confirmCancelBtn: $t({id: "Cancel"}),
                    confirmSuccessBtn: $t({id: "Confirm"}),
                    confirmedTitle: $t({id: "ConfirmSliderChange"}),
                    title: (
                        <>
                            <Icon iconName="AlertOrange" /> {$t({id: "ConfirmSliderChange"})}
                        </>
                    ),
                    confirmText: $t({id: "RewardsSlider.confirmText"}, {period: sliderConfirmModal.type === "week" ? $t({id: "week"}) : $t({id: "month"})}),
                    timerText: $t({id: "RewardsSlider.timerText"}),
                }}
                afterOpenModal={() => {
                    modal.show("reward_slider_confirm");
                }}
                onAfterClose={() => {
                    modal.close("reward_slider_confirm");
                }}
            />
        </>
    );
};
